import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FlowContext } from 'src/lib/flow';

type SerializedFlowState = {
  index: number;
  lastCompletedIndex: number;
  atStart: boolean;
  atEnd: boolean;
  exitPath: string | null;
  pageSetName: string;
  inputContext: FlowContext['inputContext'];
};

const initialState: SerializedFlowState = {
  index: 0,
  lastCompletedIndex: -1,
  atStart: true,
  atEnd: false,
  exitPath: null,
  pageSetName: '',
  inputContext: {} as FlowContext['inputContext'],
};

const slice = createSlice({
  name: 'flow_ng',
  initialState,
  reducers: {
    atStart: () => {},
    updateInputContext: (state, action: PayloadAction<FlowContext['inputContext']>) => {
      //TODO: update keys directly to prevent pointless reloads
      state.inputContext = {
        ...state.inputContext,
        ...action.payload,
      };
    },
    updateIndex: (
      state,
      action: PayloadAction<{
        index: number;
        atStart: boolean;
        atEnd: boolean;
        lastCompletedIndex?: number;
      }>,
    ) => {
      state.index = action.payload.index;
      state.atStart = action.payload.atStart;
      state.atEnd = action.payload.atEnd;
      if (action.payload.lastCompletedIndex) {
        state.lastCompletedIndex = action.payload.lastCompletedIndex;
      }
    },
    updateFlow: (
      state,
      action: PayloadAction<{
        index: number;
        atStart: boolean;
        atEnd: boolean;
        pageSetName: string;
        inputContext: FlowContext['inputContext'];
        lastCompletedIndex?: number;
      }>,
    ) => {
      state.index = action.payload.index;
      state.atStart = action.payload.atStart;
      state.atEnd = action.payload.atEnd;
      state.pageSetName = action.payload.pageSetName;
      state.inputContext = action.payload.inputContext;
      if (action.payload.lastCompletedIndex) {
        state.lastCompletedIndex = action.payload.lastCompletedIndex;
      }
    },
  },
  extraReducers: () => {
    // see flow_listeners for where we initialize on `api.endpoints.getSellerInputs.matchFulfilled`
  },
});

export const { atStart, updateIndex, updateFlow, updateInputContext } = slice.actions;

export default slice.reducer;
